/// <reference types="vite-plugin-svgr/client" />
import { clientConfig, measures, strings } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";
// import { createPortal } from "react-dom";
import PopOutPhone from "../../icons/mobile-preview.svg?react";
import { HostId } from "../../state/atoms";
import { IsInPortrait } from "../../state/selectors";
import { MousedOverTextHelper } from "../../state/uiAtoms";
import StyledControl from "../StyledControl";

export const openMobilePreview = (hostId: string) => {
  // take up half the users desktop
  const previewHeight = window.screen.availHeight / 2;
  const previewWidth = (previewHeight / 16) * 9;
  const left = window.screen.availWidth - previewWidth;

  const windowFeatures = `left=${left},top=10,width=${previewWidth},height=${previewHeight}`;
  const url = `${clientConfig.mobilePreviewUrl()}?hostId=${hostId}&inAuthor=true&pop=true`;

  // window.open with features is a "popup" — some Chrome profiles block it
  // even on a real tap and it fails silently (returns null). A synthesized
  // anchor click is link navigation: allowed under user activation everywhere,
  // opens as a tab (which is also what phones do with window.open anyway).
  const popup = window.open(url, "", windowFeatures);
  if (!popup) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  return;
};

export default function MobilePreviewButton() {
  const setTextHelper = useSetRecoilState(MousedOverTextHelper);
  const isInPortrait = useRecoilValue(IsInPortrait);
  const hostId = useRecoilValue(HostId);
  const mouseOver = () => {
    setTextHelper(strings.preview.inExternalMobile);
  };

  const handleClick = () => {
    openMobilePreview(hostId);
  };

  const mouseLeave = () => {
    setTextHelper(undefined);
  };

  return (
    <StyledControl
      onClick={handleClick}
      $dim={false}
      $isInPortrait={isInPortrait}
      onMouseOver={mouseOver}
      onMouseLeave={mouseLeave}
      $height={measures.previewButtons.icon}
      $iconHeight={measures.previewButtons.icon}
      $collapseMargin
    >
      <PopOutPhone className="preview-control open-mobile-preview-button" />
    </StyledControl>
  );
}
